"use client";

import { SelectProps as MantineSelectProps } from "@mantine/core";
import { Select as MantineSelect } from "@mantine/core";
import cx from "clsx";
import { useState } from "react";
import classes from "./index.module.css";
import { getInputProps } from "@/components/inputProps";
import { ChevronSmallDown, ChevronSmallDownGray, ChevronSmallUp } from "../Icons";

interface SelectProps extends MantineSelectProps {
  withRightSection?: boolean;
  priorityProps?: { "data-filled"?: boolean } & MantineSelectProps;
  allowDeselect?: boolean;
  /** Marks the rendered input as containing personal data so analytics tools exclude it (adds the `piiData` class). */
  pii?: boolean;
}

const Select = ({ withRightSection = true, priorityProps, allowDeselect = false, pii = false, ...selectProps }: SelectProps) => {
  const [opened, setOpened] = useState(false);
  const [focused, setFocused] = useState(false);

  return (
    <MantineSelect
      {...selectProps}
      {...getInputProps(selectProps, focused)}
      className={cx(selectProps.className, { piiData: pii })}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      size="lg"
      classNames={classes}
      dropdownOpened={opened}
      onDropdownOpen={() => {
        setOpened(true);
        selectProps.onDropdownOpen?.();
      }}
      onDropdownClose={() => {
        setOpened(false);
        selectProps.onDropdownClose?.();
      }}
      onClick={() => setOpened(true)}
      rightSectionWidth={withRightSection ? "inherit" : 0}
      rightSection={
        withRightSection ? (
          opened ? (
            <ChevronSmallUp fontSize={32} />
          ) : selectProps.disabled ? (
            <ChevronSmallDownGray fontSize={32} />
          ) : (
            <ChevronSmallDown fontSize={32} />
          )
        ) : undefined
      }
      rightSectionPointerEvents="all"
      withCheckIcon={false}
      withScrollArea={false}
      allowDeselect={allowDeselect}
      styles={{ dropdown: { maxHeight: 200, overflowY: "auto" } }}
      {...priorityProps}
    />
  );
};

export default Select;
